import { render, staticRenderFns } from "./EditaDocumentoFromComponent.vue?vue&type=template&id=6ce6487a"
import script from "./EditaDocumentoFromComponent.vue?vue&type=script&lang=js"
export * from "./EditaDocumentoFromComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports